import { useState } from 'react';
import { useAlgo } from '../hooks/useAlgo';
import { useCitizens } from '../hooks/useCitizens';
import Button from './Button';
import Spinner from './Spinner';

const RemoveFromCityButton = ({ assetId, isRenter, isMyCity, isMyKitty, onRemove }) => {
  const { address } = useAlgo();
  const showRemoveButton = (address && (isMyCity || isMyKitty)) || (address && isRenter && isMyCity && !isMyKitty);

  const { removeFromCity } = useCitizens();
  const [removeFromCityLoading, setRemoveFromCityLoading] = useState(false);

  if (!showRemoveButton) return null;

  return (
    <Button
      theme='red'
      className='flex items-center justify-center p-2 h-[45px] mt-6'
      onClick={async () => {
        try {
          setRemoveFromCityLoading(true);
          await removeFromCity(assetId, isRenter);
          onRemove?.();
        } catch (e) {
          throw e;
        } finally {
          setRemoveFromCityLoading(false);
        }
      }}
    >
      {removeFromCityLoading ? <Spinner dimensionClasses='w-5 h-5' /> : isRenter ? 'Evict' : 'Move out'}
    </Button>
  );
};

export default RemoveFromCityButton;
